"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeSign = void 0;
const __1 = require("..");
class LifeSign {
    constructor(appName, contextId, deviceName, userId, userName) {
        this.className = "LifeSign";
        this.appName = appName;
        this.contextId = contextId;
        this.deviceName = deviceName;
        this.userId = userId;
        this.userName = userName;
        if (appName && deviceName && userId) {
            this.identifier = `${appName}-${deviceName}-${userId}`;
        }
    }
    setFromAny(data) {
        // unsave 
        const { updateTimestamp, timeStamp } = data;
        Object.assign(this, data);
        this.updateTimestamp = updateTimestamp ? (0, __1.isDate)(updateTimestamp) ? updateTimestamp : (0, __1.firestoreTimestampToDate)(updateTimestamp) : this.updateTimestamp;
        this.timeStamp = timeStamp ? (0, __1.isDate)(timeStamp) ? timeStamp : (0, __1.firestoreTimestampToDate)(timeStamp) : this.timeStamp;
    }
    getListItemTitle() {
        return `${this.deviceName ? this.deviceName : "Unknown"} - ${this.userName ? this.userName : "Unknown"}`;
    }
    getListItemSubTitle(locale, options) {
        let opts = options;
        if (!opts)
            opts = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', seconds: 'numeric' };
        return `${this.updateTimestamp ? this.updateTimestamp.toLocaleTimeString(locale, opts) : "Unknown"}`;
    }
    searchFilter(filter) {
        const str = `${this.deviceName}${this.userName}`.toLowerCase();
        return str.includes(filter);
    }
    /**
     * Function for skipping objects and data while deepcopying class.
     * used as optional Input for deepCopy(any, replacerFn)
     * @param key
     */
    replacerFn(key) {
        if (key == "className")
            return false;
        else
            return true;
    }
}
exports.LifeSign = LifeSign;
